import LazyLoad from 'react-lazyload';

import { css } from '@emotion/react';

import { LAZY_LOAD_OFFSET } from 'components/globals';

import Marker, { MarkerFadeIn } from '../Marker';

interface HeroMarkersProps {
  cashOfferMarkerImage: string;
  newOfferMarkerImage: string;
  highestOfferMarkerImage: string;
}

const markerBaseStyles = css`
  ${MarkerFadeIn}
  @media (min-width: 1201px) {
    height: 80px;
    width: 195px;
  }
`;

const HeroMarkers = ({
  cashOfferMarkerImage,
  newOfferMarkerImage,
  highestOfferMarkerImage,
}: HeroMarkersProps) => {
  return (
    <>
      <LazyLoad offset={LAZY_LOAD_OFFSET}>
        <Marker
          imageSource={cashOfferMarkerImage}
          preload
          lazy={false}
          left="57%"
          top="40%"
          height={59}
          width={144}
          css={css`
            ${markerBaseStyles}
            @media (min-width: 768px) {
              left: 60%;
              top: 40%;
            }
            @media (min-width: 1201px) {
              left: 50%;
              top: 25%;
            }
          `}
          animationDelay="0.5s"
        />
      </LazyLoad>
      <LazyLoad offset={LAZY_LOAD_OFFSET}>
        <Marker
          imageSource={newOfferMarkerImage}
          preload
          lazy={false}
          right="55%"
          top="45%"
          height={59}
          width={144}
          css={css`
            ${markerBaseStyles}
            @media (min-width: 768px) {
              right: 52%;
              top: 43%;
            }
            @media (min-width: 1201px) {
              right: 57%;
              top: 30%;
            }
          `}
          animationDelay="1.5s"
        />
      </LazyLoad>
      <LazyLoad offset={LAZY_LOAD_OFFSET}>
        <Marker
          imageSource={highestOfferMarkerImage}
          preload
          lazy={false}
          right="35%"
          top="20%"
          height={59}
          width={144}
          css={css`
            ${markerBaseStyles}
            @media (min-width: 768px) {
              right: 40%;
              top: 22%;
            }
            @media (min-width: 1201px) {
              right: 36%;
              top: 7%;
            }
          `}
          animationDelay="2.5s"
        />
      </LazyLoad>
    </>
  );
};

export default HeroMarkers;
